import { IEditorPlatformApplication_unsafe } from '../types';
import {
  ApplicationsErrorCode,
  createApplicationsError,
} from './ApplicationsError';

export class Application<TPublicAPI = unknown, TPrivateAPI = unknown> {
  private application?: IEditorPlatformApplication_unsafe<
    TPublicAPI,
    TPrivateAPI
  >;
  private pendingWaiters: ((value: this) => void)[] = [];

  constructor(public readonly appDefinitionId: string) {}

  public setApplication(
    instance: IEditorPlatformApplication_unsafe<TPublicAPI, TPrivateAPI>,
  ) {
    this.application = instance;
    this.pendingWaiters.forEach((res) => res(this));
    this.pendingWaiters = [];
  }

  private ensureApplication() {
    if (!this.application) {
      throw createApplicationsError(
        ApplicationsErrorCode.ApplicationIsNotReady,
      ).withApplicationId(this.appDefinitionId);
    }

    return this.application;
  }

  public async getPublicAPI() {
    return this.ensureApplication().getPublicAPI();
  }

  public async getPrivateAPI() {
    return this.ensureApplication().getPrivateAPI();
  }

  public waitReady(): Promise<this> {
    return new Promise((res) => {
      if (this.application) {
        return res(this);
      }
      this.pendingWaiters.push(res);
    });
  }
}
